var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter, NgZone } from '@angular/core';
import { CommonConstant, CampaignInfluencerStatus } from '../../app.constants';
import { InfluencerGroup } from '../../../models/influencer-group';
import { AddInfluencersCampaign } from '../../../models/campaign/add-influencers-campaign';
import { GroupService } from '../../services/group-details/group.service';
import { UserService } from '../../services/user.service';
import { ModalService } from '../../services/modal/modal.service';
import { CampaignService } from '../../services/campaign/campaign.service';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { DiscoverService } from '../../services/discover/discover.service';
import { InfluencerGroupsService } from '../influencer-groups/influencer-groups.service';
import { Project } from '../../../models/project/project';
import { ActivePages, EventTrackerService, UserActionType, Page, ActionSource, TargetType, ActionDetails } from '../../services/event-tracker/event-tracker.service';
import { InvalidAction, WallName } from '../../../models/user';
import { AddInfluencerGroupComponent } from '../group-details/add-influencer-group/add-influencer-group.component';
import { AddInfluencersToCampaignComponent } from '../group-details/add-influencers-to-campaign/add-influencers-to-campaign.component';
import { MoveInfluencerFromGroupComponent } from '../group-details/move-influencer-from-group/move-influencer-from-group.component';
import { AddInfluencerCampaignComponent } from '../campaigns/add-influencer-campaign/add-influencer-campaign.component';
import { Campaign } from '../../../models/campaign';
import { CampaignsDetailComponent } from '../campaigns-add/campaign-detail.component';
import { ObjectUtils } from '../../utils/object.utils';
import { AddPostsToProjectComponent } from './add-posts-to-project/add-posts-to-project.component';
var DiscoverTab;
(function (DiscoverTab) {
    DiscoverTab["POST"] = "posts";
    DiscoverTab["INFLUENCER"] = "influencers";
})(DiscoverTab || (DiscoverTab = {}));
var BottombarInfluencerFragementComponent = /** @class */ (function () {
    function BottombarInfluencerFragementComponent(groupService, userService, referenceDataService, _ngZone, modalService, campaignService, translateService, discoverService, eventTracker, influencerGroupService) {
        this.groupService = groupService;
        this.userService = userService;
        this.referenceDataService = referenceDataService;
        this._ngZone = _ngZone;
        this.modalService = modalService;
        this.campaignService = campaignService;
        this.translateService = translateService;
        this.discoverService = discoverService;
        this.eventTracker = eventTracker;
        this.influencerGroupService = influencerGroupService;
        this.influencerList = [];
        this.postList = [];
        this.influencerGroupList = [];
        this.projectList = [];
        this.campaignList = [];
        this.campaignListToPost = [];
        this.isUsingForGroupDetail = false;
        this.closeBottomBarCallback = new EventEmitter();
        this.openBottomBarCallback = new EventEmitter();
        this.clearSelectionCallback = new EventEmitter();
        this.previewBottomBarOpen = new EventEmitter();
        this.beforeAddingPendingInfluencerToGroup = new EventEmitter();
        this.addPendingInfluencerToGroupError = new EventEmitter();
        // events use in Campaign Details page to add influencer to current active campaign and handle error
        this.addInfluencerToCurrentCampaign = new EventEmitter();
        this.addInfluencerToCampaignError = new EventEmitter();
        this.addInfluencerAsAccepted = new EventEmitter();
        // only use for discover clear result anfd filter
        this.clearDiscoverResultAndFilter = new EventEmitter();
        this.beforeUpdateGroupEvent = new EventEmitter();
        this.afterUpdateGroupEvent = new EventEmitter();
        this.openGroupSetting = new EventEmitter();
        this.deleteInfluencerEvent = new EventEmitter();
        this.afterAddNewProject = new EventEmitter();
        this.showAddInfluencerToGroupFragment = false;
        this.showPreviewSelectedInfluencerFragment = false;
        this.showAddInfluencerToCampaignFragment = false;
        this.showAddInfluencersToAnotherGroupFragment = false;
        this.showAddPostToProjectFragment = false;
        this.showCreateNewGroupFragment = false;
        this.showCreateNewProjectFragment = false;
        this.showAddInfluencerManuallyFragment = false;
        this.showAddInfluencerToCampaigns = false;
        // This is used for temporary hidden create new group fragment
        this.temporaryHidden = false;
        this.totalInfluencer = 0;
        this.selectedCampaign = new AddInfluencersCampaign();
        this.countryList = [];
        this.platformList = [];
        this.deleteInfluencers = [];
        this.tabKey = DiscoverTab.INFLUENCER;
        // create new project
        this.newProject = new Project();
        // this is used for revert data in case of error
        this.previousProjectData = new Project();
        // This flag use to show or hide country list in edit project component
        this.showCountryList = true;
        this.AddInfluencerToGroupFragment = false;
        // This is used for temporary hidden add influencer to group fragment
        this.temporaryHiddenAddInfluencerToGroup = false;
        this.countryList = this.referenceDataService.countries;
        this.platformList = this.referenceDataService.platforms;
        this.updateCountryCode();
    }
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "hasSelectedPost", {
        get: function () {
            return this.countNumberReviewedPost > 0;
        },
        set: function (evt) {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                _this.postList.forEach(function (post) {
                    if (post.selected) {
                        post.previewed = evt;
                    }
                });
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "hasSelectedProfiles", {
        get: function () {
            return this.countNumberReviewedInfluencer > 0;
        },
        set: function (evt) {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                if (!evt) {
                    _this.showAddInfluencerToCampaigns = false;
                    _this.showAddInfluencerToGroupFragment = false;
                }
                _this.influencerList.forEach(function (influencer) {
                    if (influencer.selected) {
                        influencer.previewed = evt;
                    }
                });
            });
        },
        enumerable: true,
        configurable: true
    });
    BottombarInfluencerFragementComponent.prototype.closeWarningDeleteInfluencerPopup = function () {
        this.deleteInfluencers = [];
        this.modalService.close();
    };
    BottombarInfluencerFragementComponent.prototype.closeWarningClearSelectedInfluencerPopup = function () {
        this.deleteInfluencers = [];
        this.modalService.close();
    };
    BottombarInfluencerFragementComponent.prototype.showAlertSuccessAddInfluencerToCampaign = function () {
        var _this = this;
        var alert = this.alertAddInfluencerToCampaignSuccess;
        this.modalService.open(alert, function () {
            _this.selectedCampaign = null;
        }, true);
    };
    BottombarInfluencerFragementComponent.prototype.showAlertSuccessAddPostsToCampaign = function () {
        var _this = this;
        var alert = this.alertAddPostToCampaignSuccess;
        this.modalService.open(alert, function () {
            _this.selectedCampaign = null;
        }, true);
    };
    BottombarInfluencerFragementComponent.prototype.showAlertSuccessAddInfluencerToGroup = function () {
        this.modalService.open(this.alertAddInfluencerToGroupSuccess, undefined, true);
    };
    BottombarInfluencerFragementComponent.prototype.showWarningDeleteMultipleInfluencerPopup = function () {
        var selecteddInfluencers = this.selectedInfluencers.filter(function (influencer) { return influencer.selected; });
        this.showWarningDeleteInfluencerPopup(selecteddInfluencers);
    };
    BottombarInfluencerFragementComponent.prototype.reviewInfluencers = function () {
        var previewedInfluencers = this.selectedInfluencers.filter(function (influencer) { return influencer.previewed; });
        if (previewedInfluencers.length === 0) {
            this.selectedInfluencers.forEach(function (influencer) {
                influencer.previewed = true;
            });
        }
        var previewedPosts = this.selectedPosts.filter(function (post) { return post.previewed; });
        if (previewedPosts.length === 0) {
            this.selectedPosts.forEach(function (influencer) {
                influencer.previewed = true;
            });
        }
        if (this.selectedInfluencers.length > 0) {
            this.showPreviewInfluencer();
            this.replaceTabState(DiscoverTab.INFLUENCER);
        }
        else if (this.selectedPosts.length > 0) {
            this.showPreviewInfluencer();
            this.replaceTabState(DiscoverTab.POST);
        }
    };
    BottombarInfluencerFragementComponent.prototype.onCheckAllPost = function (evt) {
        if (!evt) {
            return;
        }
        this.postList.forEach(function (p) { return p.previewed = evt.returnValue; });
    };
    BottombarInfluencerFragementComponent.prototype.onClearDiscoverResultAndFilter = function () {
        if (!this.discoverInfluencer) {
            return;
        }
        this.clearDiscoverResultAndFilter.emit(this.tabKey);
    };
    BottombarInfluencerFragementComponent.prototype.showWarningDeleteInfluencerPopup = function (influencers) {
        this.deleteInfluencers = influencers;
        this.modalService.openInCenter(this.warningDeleteInfluencerDialog);
    };
    BottombarInfluencerFragementComponent.prototype.showWarningClearSelectedInfluencerPopup = function () {
        this.modalService.openInCenter(this.WarningClearSelectedInfluencerDialog);
    };
    BottombarInfluencerFragementComponent.prototype.shouldShowInfluencerActionButton = function () {
        return !this.showAddInfluencerToGroupFragment && !this.showAddInfluencerToCampaignFragment && !this.showAddPostToProjectFragment
            && !this.showCreateNewGroupFragment && !this.showCreateNewProjectFragment
            && !this.showAddInfluencerManuallyFragment
            && !this.showAddInfluencersToAnotherGroupFragment && (this.discoverInfluencer || (this.hasSelectedInfluencer() && !this.discoverInfluencer));
    };
    BottombarInfluencerFragementComponent.prototype.shouldShowActionButtons = function () {
        return this.discoverInfluencer && !this.showPreviewSelectedInfluencerFragment && !this.showAddPostToProjectFragment
            && !this.showCreateNewProjectFragment && !this.showAddInfluencerToCampaignFragment && !this.showCreateNewGroupFragment
            && !this.showAddInfluencersToAnotherGroupFragment && !this.showAddInfluencerManuallyFragment;
    };
    BottombarInfluencerFragementComponent.prototype.shouldShowGroupActionButton = function () {
        return !this.showAddInfluencerToGroupFragment && !this.showAddInfluencerManuallyFragment
            && !this.hasSelectedInfluencer() && !this.showAddInfluencerToCampaigns
            && !this.showCreateNewGroupFragment && !this.showCreateNewProjectFragment;
    };
    BottombarInfluencerFragementComponent.prototype.showNotificationAfterAddingPostToProject = function (projectName) {
        this.projectName = projectName;
        this.modalService.open(this.notificationAfterAddPostToProject, this.hideNotificationAddingPostToProject.bind(this), true);
    };
    BottombarInfluencerFragementComponent.prototype.hideNotificationAddingPostToProject = function () {
        this.projectName = undefined;
    };
    BottombarInfluencerFragementComponent.prototype.closeNotificationAddPostToProject = function () {
        this.hideNotificationAddingPostToProject();
        this.modalService.close();
    };
    BottombarInfluencerFragementComponent.prototype.hideAddToCampaignFragment = function (needToResetPendingData) {
        if (needToResetPendingData) {
            this.selectedCampaign = null;
        }
        this.showAddInfluencerToCampaignFragment = false;
        this.showPreviewSelectedInfluencerFragment = true;
        this.openBottomBarToPreview();
    };
    BottombarInfluencerFragementComponent.prototype.hideMoveInfluencerFragment = function (needToDiscardPendingData) {
        if (needToDiscardPendingData) {
            this.addInfluencerGroup = null;
        }
        this.showAddInfluencersToAnotherGroupFragment = false;
        this.showPreviewSelectedInfluencerFragment = true;
        this.openBottomBarToPreview();
    };
    BottombarInfluencerFragementComponent.prototype.hideAddPostToProjectFragment = function () {
        this.showAddPostToProjectFragment = false;
        this.showPreviewSelectedInfluencerFragment = true;
        this.openBottomBarToPreview();
    };
    BottombarInfluencerFragementComponent.prototype.previewSelectedInfluencersToCampaign = function () {
        var previewedInfluencers = this.selectedInfluencers.filter(function (influencer) { return influencer.previewed; });
        if (previewedInfluencers.length === 0) {
            this.selectedInfluencers.forEach(function (influencer) {
                influencer.previewed = true;
            });
        }
        // set timeout to run animation
        this.showPreviewInfluencer();
    };
    BottombarInfluencerFragementComponent.prototype.addSelectedInfluencersToGroup = function () {
        this.showPreviewSelectedInfluencerFragment = false;
        this.showAddingInfluencersToGroupFragment();
    };
    BottombarInfluencerFragementComponent.prototype.addSelectedPostsToProject = function () {
        this.showPreviewSelectedInfluencerFragment = false;
        this.showAddMultiplePostsToProject();
    };
    BottombarInfluencerFragementComponent.prototype.addSelectedInfluencersToCampaign = function () {
        this.showPreviewSelectedInfluencerFragment = false;
        this.showAddInfluencerToCampaignFragment = true;
        this.openBottomBarCallback.emit();
    };
    BottombarInfluencerFragementComponent.prototype.onClickOutSideBottomBar = function (evt) {
        if (this.showPreviewSelectedInfluencerFragment && document.contains(evt.target)) {
            this.clearPreviewedInfluencer();
        }
    };
    /**
     * Clear influencer selection
     * Clear influencer and post base on the current tab on bottombar
     */
    BottombarInfluencerFragementComponent.prototype.clearInfluencerSelection = function () {
        if (this.tabKey === DiscoverTab.INFLUENCER) {
            this.unCheckAllInfluencers();
            // move to posts tab if there is some data selected
            if (this.countNumberSelectedPost() > 0) {
                this.tabKey = DiscoverTab.POST;
            }
            else {
                this.closeBottomBarWithTransition();
            }
        }
        else if (this.tabKey === DiscoverTab.POST) {
            this.unCheckAllPosts();
            // move to influencers tab if there is some data selected
            if (this.countNumberSelectedInfluencer() > 0) {
                this.tabKey = DiscoverTab.INFLUENCER;
            }
            else {
                this.closeBottomBarWithTransition();
            }
        }
        this.modalService.close();
    };
    /**
     * Clear selected and previewed influencer and post
     * Base on the current tab on bottombar
     */
    BottombarInfluencerFragementComponent.prototype.clearPreviewedInfluencerOrPost = function () {
        if (this.tabKey === DiscoverTab.INFLUENCER || !this.discoverInfluencer) {
            this.influencerList.forEach(function (influencer) {
                if (influencer.selected && influencer.previewed) {
                    influencer.previewed = false;
                    influencer.selected = false;
                }
            });
        }
        else if (this.tabKey === DiscoverTab.POST) {
            this.postList.forEach(function (influencer) {
                if (influencer.selected && influencer.previewed) {
                    influencer.previewed = false;
                    influencer.selected = false;
                }
            });
        }
        if (this.isUsingForGroupDetail) {
            this.clearSelectionCallback.emit();
        }
        // move to posts tab if there is some data selected
        this.manageDisplayTabAndCloseBottombar();
        this.modalService.close();
    };
    /**
     * Clear previewed Influencers and Posts base on the selected tab
     * Display the next tab if there is some selected data
     */
    BottombarInfluencerFragementComponent.prototype.clearPreviewedInfluencer = function () {
        var _this = this;
        setTimeout(function () {
            _this.closeAllActionsFragment();
        }, CommonConstant.TRANSITION_TIME);
        this.closeBottomBarCallback.emit(false);
        this.previewBottomBarOpen.emit(false);
    };
    /**
     * show fragement to add new influencer to group
     */
    BottombarInfluencerFragementComponent.prototype.showAddInfluencerFragment = function () {
        var _this = this;
        // set timeout for animation
        setTimeout(function () {
            if (_this.campaignInfluencerList) {
                _this.showAddInfluencerToCampaigns = true;
            }
            else {
                _this.showAddInfluencerToGroupFragment = true;
                _this.temporaryHiddenAddInfluencerToGroup = false;
            }
        }, CommonConstant.TRANSITION_TIME);
        this.openBottomBarCallback.emit();
    };
    BottombarInfluencerFragementComponent.prototype.closeAddInfluencerFragment = function (data) {
        var _this = this;
        setTimeout(function () {
            if (_this.campaignInfluencerList) {
                _this.showAddInfluencerToCampaigns = false;
            }
            else {
                if (!data.isTemporaryHidden) {
                    _this.showAddInfluencerToGroupFragment = false;
                    _this.temporaryHiddenAddInfluencerToGroup = false;
                }
                else {
                    _this.temporaryHiddenAddInfluencerToGroup = true;
                }
            }
        }, CommonConstant.TRANSITION_TIME);
        if (data && data.resetSelectedInfluencer) {
            // clear cached influencer selection
            this.selectedInfluencerToAddGroup = [];
            this.addInfluencerGroup = null;
        }
        if (data) {
            this.closeBottomBarCallback.emit(data);
        }
    };
    /**
     * show fragment to move multiple influencers to other group
     */
    BottombarInfluencerFragementComponent.prototype.showAddingInfluencersToGroupFragment = function () {
        this.openBottomBarCallback.emit(CommonConstant.DEFAULT_BOTTOMBAR_MAX_HEIGHT);
        this.showAddInfluencersToAnotherGroupFragment = true;
    };
    /**
     * show fragment to move multiple influencers to other group
     */
    BottombarInfluencerFragementComponent.prototype.showAddMultiplePostsToProject = function () {
        // calculate expected fragment bottom bar height container
        var previewFragmentHeight = this.selectedPosts.length * CommonConstant.PREVIEW_ITEM_HEIGHT + CommonConstant.COLLAPSED_BOTTOMBAR_HEIGHT;
        if (previewFragmentHeight < 500) {
            this.openBottomBarCallback.emit(500);
        }
        this.showAddPostToProjectFragment = true;
    };
    BottombarInfluencerFragementComponent.prototype.closeMoveInfluencersToGroup = function () {
        var _this = this;
        setTimeout(function () {
            _this.showAddInfluencersToAnotherGroupFragment = false;
        }, CommonConstant.TRANSITION_TIME);
        this.closeBottomBarCallback.emit(false);
    };
    BottombarInfluencerFragementComponent.prototype.showCreateProjectFragement = function (project, isAddingPost) {
        this.isAddingPostToNewProject = isAddingPost;
        this.showCountryList = isAddingPost;
        if (!project) {
            // initialize value for new project
            this.newProject = new Project();
            this.newProject.id = 0;
            this.newProject.countries = [];
        }
        else {
            this.newProject = project;
        }
        this.previousProjectData = ObjectUtils.deepClone(this.newProject);
        // show project creation fragment
        this.showAddPostToProjectFragment = false;
        this.showCreateNewProjectFragment = true;
    };
    BottombarInfluencerFragementComponent.prototype.beforeCreateOrUpdateProject = function () {
        if (!this.isAddingPostToNewProject) {
            this.showCreateNewProjectFragment = false;
            this.closeBottomBarWithTransition();
        }
    };
    BottombarInfluencerFragementComponent.prototype.closeEditProjectFragment = function (evt) {
        if (evt.isError) {
            this.newProject = this.previousProjectData;
            this.showCreateNewProjectFragment = true;
            this.openBottomBarCallback.emit();
        }
        else {
            if (this.isAddingPostToNewProject) {
                this.isAddingPostToNewProject = false;
                this.showCreateNewProjectFragment = false;
                this.showAddPostToProjectFragment = true;
                if (evt.isReloadList) {
                    this.afterCreateProjectSuccess(evt);
                }
            }
            else {
                this.showCreateNewProjectFragment = false;
                this.closeBottomBarWithTransition();
            }
        }
    };
    BottombarInfluencerFragementComponent.prototype.replaceTabState = function (tabKey) {
        if (!this.showPreviewSelectedInfluencerFragment) {
            return;
        }
        this.tabKey = tabKey;
        var activedInfluencerTabWithoutSelectedInfluencer = tabKey === DiscoverTab.INFLUENCER && this.selectedInfluencers.length === 0;
        var activedPostTabWithoutSelectedPost = tabKey === DiscoverTab.POST && this.selectedPosts.length === 0;
        if (activedInfluencerTabWithoutSelectedInfluencer && activedPostTabWithoutSelectedPost) {
            this.showPreviewSelectedInfluencerFragment = false;
            this.closeBottomBarCallback.emit(false);
        }
    };
    /*Public method -----------------------------------------------*/
    /**
     * @param {AddInfluencerGroup} addInfluencerGroup
     */
    BottombarInfluencerFragementComponent.prototype.addMoreInfluencerToCurrentGroup = function (data) {
        // clear cached selected influencer suggestions
        this.selectedInfluencerToAddGroup = data.selectedInfluencers;
        this.addInfluencerToGroup(data.addInfluencerGroup, false);
    };
    BottombarInfluencerFragementComponent.prototype.addInfluencerToCampaign = function (addInfluencerCampaign) {
        var _this = this;
        // filter list of previewed influencers
        var previewedInfluencers = [];
        if (this.tabKey === DiscoverTab.INFLUENCER) {
            previewedInfluencers = this.influencerList.filter(function (influencer) { return influencer.selected && influencer.previewed; });
        }
        // prepare influencer data to webservice
        addInfluencerCampaign.influencers = previewedInfluencers.map(function (pi) { return ({
            influencer_id: pi.influencer_id,
            action: CommonConstant.ADD_ACTION,
            status: addInfluencerCampaign.is_accepted ? CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase() : ''
        }); });
        // update selected campaign
        this.selectedCampaign = addInfluencerCampaign;
        // close add to campaign fragement
        this.hideAddToCampaignFragment();
        this.campaignService.addInfluencerToCampaign(addInfluencerCampaign).subscribe(function (res) {
            if (!addInfluencerCampaign.is_accepted) {
                _this.sendChamMixpanelEvent(true);
            }
            var messageTemplate;
            var param = {
                selected_campaign: _this.selectedCampaign.campaign_name
            };
            // build notification message
            if (previewedInfluencers.length === 1) {
                messageTemplate = 'group_details.influencer.add_one_influencer_to_campaign';
            }
            else {
                messageTemplate = 'group_details.influencer.add_more_influencers_to_campaign';
            }
            _this.campaignNotificationMsg = _this.translateService.instant(messageTemplate, param);
            _this.showAlertSuccessAddInfluencerToCampaign();
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                id: addInfluencerCampaign.campaign_id,
                name: addInfluencerCampaign.campaign_name,
                type: TargetType.CAMPAIGN
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.ACTION_VIEW, actionDetails: ActionDetails.ADDED_INFLUENCERS }, addInfluencerCampaign), undefined, _this.getActivePage());
            _this.userService.triggerUpdateActivatedInfluencers();
        }, // handler Error
        function (err) {
            // error by account level, show message
            _this.addSelectedInfluencersToCampaign();
            if (err.error.data === 'invalid_level') {
                _this.userService.doInvalidActionByLevel('Add to Campaign', err.error.message);
                _this.sendInvalidActionToSegement(_this.influencerGroupService.extractLimitInfoFromErrorMessage(err.error.message, addInfluencerCampaign.influencers.length, _this.userService.maxCampaignInfluencers, true), null, addInfluencerCampaign);
            }
            else if (err.error.data === 'archived_campaign') {
                _this.modalService.openInCenter(_this.addInfluencerToCampaignErrorPopup);
            }
        });
    };
    BottombarInfluencerFragementComponent.prototype.getActivePage = function () {
        var _this = this;
        if (this.isUsingForGroupDetail) {
            return {
                type: ActivePages.GROUP_DETAILS,
                name: this.influencerGroup && this.influencerGroup.influencer_group_name ? this.influencerGroup.influencer_group_name : undefined,
                id: this.influencerGroupId ? this.influencerGroupId : undefined,
            };
        }
        else if (this.discoverInfluencer) {
            return {
                type: ActivePages.DISCOVER,
                name: undefined,
                id: undefined,
            };
        }
        else {
            var activeCampaign = this.campaignList.find(function (cp) { return cp.id === _this.campaignId; });
            if (activeCampaign) {
                return {
                    type: ActivePages.CAMPAIGN_DETAILS,
                    name: activeCampaign.name,
                    id: activeCampaign.id,
                };
            }
            throw new Error('Not found active page');
        }
    };
    /**
     * this method is used to add multiple posts into selected campaign
     * @param {AddInfluencersCampaign} campaign
     */
    BottombarInfluencerFragementComponent.prototype.addPostsToCampaign = function (campaign) {
        var _this = this;
        // filter list of previewed influencers
        var previewedPosts = [];
        previewedPosts = this.postList.filter(function (influencer) { return influencer.selected && influencer.previewed; });
        var postPaths = previewedPosts.map(function (post) { return ({
            urlHash: post.url_hash,
            influencerId: post.influencer_id,
            url: post.fullUrl,
            relativepath: post.relativepath,
            publishDate: post.date,
            title: post.title,
            image: post.imageUrl,
            status: campaign.is_accepted ? 'accepted' : 'invited',
            channelId: post.channel ? post.channel.id : null
        }); });
        this.hideAddToCampaignFragment();
        this.selectedCampaign = campaign;
        this.campaignService.addPostsToCampaign(campaign.campaign_id, postPaths).subscribe(function (res) {
            // build notification message
            _this.showAlertSuccessAddPostsToCampaign();
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                id: campaign.campaign_id,
                name: campaign.campaign_name,
                type: TargetType.CAMPAIGN
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.ACTION_VIEW, actionDetails: ActionDetails.ADDED_POSTS }, previewedPosts), undefined, {
                type: ActivePages.DISCOVER,
            });
            _this.userService.triggerUpdateActivatedInfluencers();
        }, function (error) {
            // reopen add influencer fragment if any error
            _this.addSelectedInfluencersToCampaign();
            var serverError = CampaignsDetailComponent.buildMessageErrorInArchive(error.error, _this.translateService);
            if (serverError.errorType === 'invalid level') {
                _this.userService.doInvalidActionByLevel('Add to Campaign', serverError.errorMsg);
                _this.sendInvalidActionToSegement(_this.influencerGroupService.extractLimitInfoFromErrorMessage(error.error.message, postPaths.length, _this.userService.maxCampaignInfluencers, true), null, {
                    campaign_id: campaign.campaign_id,
                    campaign_name: campaign.campaign_name,
                    posts: postPaths
                });
            }
            else {
                _this.serverErrorMessage = serverError.errorMsg;
                _this.modalService.open(_this.serverErrorNotification, _this.beforeClearErrorNotif.bind(_this), true);
            }
        });
    };
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "numberPreviewedPost", {
        get: function () {
            return this.postList.filter(function (influencer) { return influencer.selected && influencer.previewed; }).length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * move one or more influencers from current active group
     * @param {number[]} selectedInfluencerIds
     */
    BottombarInfluencerFragementComponent.prototype.executeAddingInfluencerToGroup = function (moveInfluencerGroup) {
        if (this.discoverInfluencer && this.tabKey === DiscoverTab.POST) {
            // only allow move influencer in discover influencer tab or group details
            return;
        }
        // Get selected influencers
        var selectedAndPreviewedInfluencers = this.selectedInfluencers.filter(function (influencer) { return influencer.previewed; });
        // Get array of influencer IDs for selected influencers
        var influencerIdList = selectedAndPreviewedInfluencers.map(function (influencer) { return influencer.influencer_id; });
        // Filter unknown influencers from list of selected influencers
        moveInfluencerGroup.influencerList = influencerIdList.filter(function (id) { return id > 0; });
        // Move selected and existing influencers to new group
        var isMove = this.discoverInfluencer || this.campaignInfluencerList || this.isRecentlyVisitedInfluencerGroup ? false : true;
        this.addInfluencerToGroup(moveInfluencerGroup, isMove);
    };
    /**
     * using to add multiple post into project
     * @param {AddPostToProject} addPostToProject
     */
    BottombarInfluencerFragementComponent.prototype.addMultiplePostIntoProject = function (addPostToProject) {
        var _this = this;
        if (this.tabKey !== DiscoverTab.POST) {
            // only allow move influencer in discover post tab
            return;
        }
        // Get selected influencers from post
        var selectedAndPreviewedPosts = this.selectedPosts.filter(function (post) { return post.previewed; });
        // transform to data structure to submit to server
        var postData = selectedAndPreviewedPosts.map(function (post) { return ({
            postUrlHash: post.url_hash,
            postRelativePath: post.relativepath,
            channelId: post.channel ? post.channel.id : null
        }); });
        addPostToProject.posts = postData;
        this.hideAddPostToProjectFragment();
        this.discoverService.addPostsToProject(addPostToProject).subscribe(function (res) {
            _this.showNotificationAfterAddingPostToProject(addPostToProject.projectName);
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.PROJECT, {
                id: addPostToProject.projectId,
                name: addPostToProject.projectName,
                type: TargetType.PROJECT
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.ACTION_VIEW, actionDetails: ActionDetails.ADDED_POSTS }, postData), undefined, {
                type: ActivePages.DISCOVER,
            });
        });
    };
    BottombarInfluencerFragementComponent.prototype.deleteSelectedInfluencers = function () {
        this.deleteInfluencerEvent.emit({
            influencerToDelete: this.deleteInfluencers
        });
        this.closeWarningDeleteInfluencerPopup();
    };
    BottombarInfluencerFragementComponent.prototype.shouldDisableActionButtonGroup = function () {
        return this.showPreviewSelectedInfluencerFragment &&
            !this.hasPreviewedInfluencer();
    };
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "selectedInfluencers", {
        get: function () {
            return this.influencerList.filter(function (influencer) { return influencer.selected; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "selectedPosts", {
        get: function () {
            return this.postList.filter(function (influencer) { return influencer.selected; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "numOfInfluencerToDelete", {
        get: function () {
            return this.deleteInfluencers.length;
        },
        enumerable: true,
        configurable: true
    });
    BottombarInfluencerFragementComponent.prototype.beforeCreateOrUpdateGroup = function (evt) {
        this.beforeUpdateGroupEvent.emit(evt);
    };
    BottombarInfluencerFragementComponent.prototype.afterCreateOrUpdateGroup = function (evt) {
        if (evt && evt.isCreated) {
            this.afterCreateGroupSuccess(evt.data);
        }
        else {
            this.afterUpdateGroupEvent.emit(evt);
        }
    };
    /**
     * Callback after create new group
     */
    BottombarInfluencerFragementComponent.prototype.afterCreateGroupSuccess = function (persistedGroup) {
        var _this = this;
        this.showCreateNewGroupFragment = false;
        this.temporaryHiddenAddInfluencerToGroup = false;
        this.showAddingInfluencersToGroupFragment();
        var companyId = this.userService.getCompanyId();
        // load list influencer group
        this.influencerGroupService.getInfluencerGroupShortList(companyId).subscribe(function (res) {
            _this.influencerGroupList = res.map(function (group) { return ({
                id: group.id,
                name: group.name,
                description: group.description
            }); });
            // Find the new group and add the selected influencers to new group
            var newGroup = res.find(function (group) { return group.name === persistedGroup.name; });
            if (newGroup && _this.addInfluencerToOtherGroupFragment) {
                _this.addInfluencerToOtherGroupFragment.influencerGroup.influencer_group_id = newGroup.id;
                _this.addInfluencerToOtherGroupFragment.influencerGroup.influencerGroupName = newGroup.name;
                _this.addInfluencerToOtherGroupFragment.influencerGroup.description = newGroup.description;
            }
        });
    };
    BottombarInfluencerFragementComponent.prototype.afterCreateProjectSuccess = function (newPersistedProject) {
        var _this = this;
        var newProject = {
            id: newPersistedProject.projectData.id,
            name: newPersistedProject.projectData.name,
            advertiserId: null,
            countries: newPersistedProject.projectData.projectCountries.map(function (item) { return item.country.id; }),
            keywords: newPersistedProject.projectData.projectKeywords.map(function (item) { return item.keyword; })
        };
        this.afterAddNewProject.emit(newProject);
        this._ngZone.runOutsideAngular(function () {
            setTimeout(function () {
                if (_this.addPostsToProject) {
                    _this.addPostsToProject.onSelectProject(newProject);
                }
            });
        });
    };
    BottombarInfluencerFragementComponent.prototype.closeCreateGroupFragment = function () {
        this.showCreateNewGroupFragment = false;
        if (this.influencerGroup) {
            this.showAddInfluencersToAnotherGroupFragment = false;
            this.closeBottomBarCallback.emit();
        }
        else {
            this.showAddInfluencersToAnotherGroupFragment = true;
        }
    };
    BottombarInfluencerFragementComponent.prototype.openCreateNewGroupFragment = function (evt) {
        this.addInfluencerGroup = evt;
        this.influencerGroup = null;
        this.showAddInfluencersToAnotherGroupFragment = false;
        this.showCreateNewGroupFragment = true;
        this.temporaryHidden = false;
    };
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "messageWhenClearPreviewedItem", {
        get: function () {
            if (this.tabKey === DiscoverTab.INFLUENCER || !this.discoverInfluencer) {
                return this.translateService.instant('discover.influencer.remove_influencer_selection_confirm', {
                    totalInfluencer: this.influencerList.filter(function (influ) { return influ.previewed && influ.selected; }).length
                });
            }
            else {
                return this.translateService.instant('discover.influencer.remove_post_selection_confirm', {
                    totalPost: this.postList.filter(function (influ) { return influ.previewed && influ.selected; }).length
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    BottombarInfluencerFragementComponent.prototype.closeConfirmationPopup = function () {
        this.modalService.close();
    };
    BottombarInfluencerFragementComponent.prototype.contactSupport = function () {
        this.userService.contactSupport();
    };
    BottombarInfluencerFragementComponent.prototype.closeErrorAddingInfluencerAlert = function () {
        if (this.addInfluencerToGroupErrorPopupRef) {
            this.modalService.closeSinglePopup(this.addInfluencerToGroupErrorPopupRef);
        }
    };
    BottombarInfluencerFragementComponent.prototype.showFragmentAddInfluencerManually = function (evt) {
        // keep the previous selections
        this.indexInfluencerManually = evt.processingIndex;
        this.processingInfluencerSuggestion = evt.influencerSuggestion;
        if (this.isUsingForGroupDetail) {
            this.selectedInfluencerToAddGroup = evt.selectedInfluencers;
            this.showAddInfluencerToGroupFragment = false;
            this.addInfluencerGroup = evt.pendingAddInfluencerToGroup;
        }
        if (this.campaignInfluencerList) {
            this.pendingInfluencerListAddToCampaign = undefined;
            this.selectedInfluencerToAddCampaign = evt.selectedInfluencers;
            this.showAddInfluencerToCampaigns = false;
            this.addInfluencerToCampaignAsAccepted = evt.addInfluencerAsAccepted;
        }
        this.showAddInfluencerManuallyFragment = true;
    };
    BottombarInfluencerFragementComponent.prototype.closeFragmentAddInfluencerManually = function (influencer) {
        if (influencer && this.indexInfluencerManually && this.isUsingForGroupDetail) {
            this.selectedInfluencerToAddGroup.splice(this.indexInfluencerManually, 1, influencer);
        }
        if (influencer && this.campaignInfluencerList) {
            this.selectedInfluencerToAddCampaign.splice(this.indexInfluencerManually, 1, influencer);
        }
        this.processingInfluencerSuggestion = null;
        this.indexInfluencerManually = null;
        // keep the previous selections
        if (this.isUsingForGroupDetail) {
            this.showAddInfluencerToGroupFragment = true;
        }
        if (this.campaignInfluencerList) {
            this.showAddInfluencerToCampaigns = true;
        }
        this.showAddInfluencerManuallyFragment = false;
    };
    BottombarInfluencerFragementComponent.prototype.getWallNameForAddingInfluencer = function () {
        if (this.isUsingForGroupDetail) {
            return WallName.GROUPS_DISABLED;
        }
        if (this.campaignInfluencerList) {
            return WallName.CAMPAIGNS_DISABLED;
        }
        return null;
    };
    BottombarInfluencerFragementComponent.prototype.getActionLevelForAddingInfluencer = function () {
        if (this.isUsingForGroupDetail) {
            return CommonConstant.ADD_INFLUENCER_TO_GROUP;
        }
        if (this.campaignInfluencerList) {
            return CommonConstant.BASIC_CAMPAIGN_ACTION;
        }
        return null;
    };
    /*Private method -----------------------------------------------*/
    /**
     * this method is used to adda list of selected or previewed influencer to a Group
     * @param {AddInfluencerGroup} influencerToAdd
     * @param {boolean} isMove
     */
    BottombarInfluencerFragementComponent.prototype.addInfluencerToGroup = function (influencerToAdd, isMove) {
        this.addInfluencerGroup = influencerToAdd;
        // move influencer from one group to another group
        // use for discover and group details
        if (isMove) {
            this.hideMoveInfluencerFragment();
            if (influencerToAdd.addForReview) {
                this.addInfluencerToGroupAsPending(influencerToAdd, true);
            }
            else {
                this.doAddInfluencerToGroupManually(influencerToAdd);
            }
        }
        else {
            if (this.discoverInfluencer || this.campaignInfluencerList || this.isRecentlyVisitedInfluencerGroup) {
                this.hideMoveInfluencerFragment();
            }
            if (influencerToAdd.addForReview) {
                this.addInfluencerToGroupAsPending(influencerToAdd, false);
            }
            else {
                this.doAddInfluencerToGroupManually(influencerToAdd);
            }
        }
    };
    BottombarInfluencerFragementComponent.prototype.moveInfluencerToAnotherGroup = function (influencerToAdd) {
        var _this = this;
        this.groupService.moveInfluencerToGroup(this.influencerGroupId, influencerToAdd.influencerList, influencerToAdd.influencer_group_id, this.userService.getCompanyId()).subscribe(function (res) {
            _this.msgAddInfluencerToGroupSuccess = _this.translateService.instant('group_details.influencer.add_influencer_to_group');
            _this.showAlertSuccessAddInfluencerToGroup();
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
                id: influencerToAdd.influencer_group_id,
                name: influencerToAdd.influencerGroupName,
                type: TargetType.INFLUENCER_GROUP
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.ACTION_VIEW, actionDetails: ActionDetails.MOVED_INFLUENCERS }, influencerToAdd), undefined, {
                type: _this.discoverInfluencer ? ActivePages.DISCOVER : ActivePages.GROUP_DETAILS,
                name: !_this.discoverInfluencer ? _this.influencerGroup.influencer_group_name : undefined,
                id: !_this.discoverInfluencer ? _this.influencerGroupId : undefined,
            }, {
                source_type: TargetType.INFLUENCER_GROUP,
                source_name: _this.influencerGroup.influencer_group_name,
                source_id: _this.influencerGroupId
            });
        }, function (error) {
            if (error.error.data === 'invalid_level') {
                _this.userService.doInvalidActionByLevel('Add to Group', error.error.message);
                _this.sendInvalidActionToSegement(_this.influencerGroupService.extractLimitInfoFromErrorMessage(error.error.message, influencerToAdd.influencerList.length, _this.userService.maxGroupInfluencers, false), influencerToAdd, null);
            }
        });
    };
    BottombarInfluencerFragementComponent.prototype.addInfluencerToGroupAsPending = function (influencerToAdd, isMove) {
        var _this = this;
        if (this.isUsingForGroupDetail && !isMove) {
            this.beforeAddingPendingInfluencerToGroup.emit(this.selectedInfluencerToAddGroup);
        }
        this.groupService.addInfluencerToGroupAsPending(influencerToAdd).subscribe(function (res) {
            _this.afterAddingInfluencerToGroupSuccess(influencerToAdd, true);
        }, function (err) {
            if (_this.isUsingForGroupDetail && !isMove) {
                // this feature only aupport in group details page
                _this.addPendingInfluencerToGroupError.emit();
                _this.showAddInfluencerFragment();
            }
            else {
                _this.showAddingInfluencersToGroupFragment();
            }
            _this.addInfluencerToGroupErrorPopupRef = _this.modalService.openInCenter(_this.addInfluencerToGroupErrorPopup);
        });
    };
    BottombarInfluencerFragementComponent.prototype.doAddInfluencerToGroupManually = function (influencerToAdd) {
        var _this = this;
        this.groupService.addInfluencerToGroup(influencerToAdd).subscribe(function (res) {
            _this.afterAddingInfluencerToGroupSuccess(influencerToAdd, false);
            _this.sendChamMixpanelEvent(false);
        }, function (err) {
            if (_this.isUsingForGroupDetail) {
                // this feature only aupport in group details page
                _this.showAddInfluencerFragment();
            }
            else {
                _this.showAddingInfluencersToGroupFragment();
            }
            if (err.error && err.error.data === 'invalid_level') {
                _this.userService.doInvalidActionByLevel('Add to Group', err.error.message);
                _this.sendInvalidActionToSegement(_this.influencerGroupService.extractLimitInfoFromErrorMessage(err.error.message, influencerToAdd.influencerList.length, _this.userService.maxGroupInfluencers, false), influencerToAdd, null);
            }
            else {
                _this.addInfluencerToGroupErrorPopupRef = _this.modalService.openInCenter(_this.addInfluencerToGroupErrorPopup);
            }
        });
    };
    BottombarInfluencerFragementComponent.prototype.afterAddingInfluencerToGroupSuccess = function (influencerToAdd, addForReview) {
        if (addForReview) {
            this.msgAddInfluencerToGroupSuccess = this.translateService.instant('group_details.influencer.add_influencer_as_pending');
        }
        else {
            var messageKey = influencerToAdd.influencerList.length > 1
                ? 'group_details.influencer.add_new_influencers_to_current_group'
                : 'group_details.influencer.add_new_influencer_to_current_group';
            this.msgAddInfluencerToGroupSuccess = this.translateService.instant(messageKey, {
                numOfInfluencer: influencerToAdd.influencerList.length,
                groupName: influencerToAdd.influencerGroupName
            });
        }
        this.showAlertSuccessAddInfluencerToGroup();
        // when add influencer from previewed. Do not close bottom bar. Just back to previewed list
        if (!this.showPreviewSelectedInfluencerFragment) {
            this.closeAddInfluencerFragment({
                resetSelectedInfluencer: true,
                isReloadInfluencerList: true
            });
        }
        if (!addForReview) {
            // track event to Segment
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
                id: influencerToAdd.influencer_group_id,
                name: influencerToAdd.influencerGroupName,
                type: TargetType.INFLUENCER_GROUP
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.ACTION_VIEW, actionDetails: ActionDetails.ADDED_INFLUENCERS }, influencerToAdd), undefined, {
                type: this.discoverInfluencer ? ActivePages.DISCOVER : ActivePages.GROUP_DETAILS,
                name: !this.discoverInfluencer ? influencerToAdd.influencerGroupName : undefined,
                id: !this.discoverInfluencer ? influencerToAdd.influencer_group_id : undefined,
            });
        }
        // clear cached influencer selection
        this.selectedInfluencerToAddGroup = [];
        this.addInfluencerGroup = null;
    };
    BottombarInfluencerFragementComponent.prototype.sendInvalidActionToSegement = function (limitInfo, influencerAddToGroup, influencerAddToCampaign) {
        var detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true, limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);
        // send event when adding influencer to group
        if (influencerAddToGroup) {
            this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.GROUP, {
                id: influencerAddToGroup.influencer_group_id,
                name: influencerAddToGroup.influencerGroupName,
                type: TargetType.INFLUENCER_GROUP
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.ACTION_VIEW, actionDetails: ActionDetails.ADDED_INFLUENCERS }, influencerAddToGroup), undefined, {
                type: this.discoverInfluencer ? ActivePages.DISCOVER : ActivePages.GROUP_DETAILS,
                name: !this.discoverInfluencer ? influencerAddToGroup.influencerGroupName : undefined,
                id: !this.discoverInfluencer ? influencerAddToGroup.influencer_group_id : undefined,
            });
        }
        // send event when adding to Campaign
        if (influencerAddToCampaign) {
            this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.CAMPAIGN, {
                id: influencerAddToCampaign.campaign_id,
                name: influencerAddToCampaign.campaign_name,
                type: TargetType.CAMPAIGN
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.ACTION_VIEW, actionDetails: ActionDetails.ADDED_INFLUENCERS }, influencerAddToCampaign), undefined, {
                type: this.discoverInfluencer ? ActivePages.DISCOVER : ActivePages.CAMPAIGN_DETAILS,
                name: !this.discoverInfluencer ? influencerAddToCampaign.campaign_name : undefined,
                id: !this.discoverInfluencer ? influencerAddToCampaign.campaign_id : undefined,
            });
        }
    };
    BottombarInfluencerFragementComponent.prototype.updateCountryCode = function () {
        var _this = this;
        this.influencerList.forEach(function (influencer) {
            influencer.country_code = _this.findCountryCodeByName(influencer.country.name);
        });
    };
    BottombarInfluencerFragementComponent.prototype.findCountryCodeByName = function (countryName) {
        var matchCountry = this.countryList.filter(function (country) { return country.name === countryName; })[0];
        return matchCountry !== undefined ? matchCountry.code : null;
    };
    BottombarInfluencerFragementComponent.prototype.beforeClearErrorNotif = function () {
        this.serverErrorMessage = null;
    };
    BottombarInfluencerFragementComponent.prototype.closeAllActionsFragment = function () {
        this.showAddInfluencerToCampaignFragment = false;
        this.showPreviewSelectedInfluencerFragment = false;
        this.showAddInfluencersToAnotherGroupFragment = false;
    };
    BottombarInfluencerFragementComponent.prototype.hasSelectedInfluencer = function () {
        if (this.postList) {
            return this.countNumberSelectedInfluencer() > 0 || this.countNumberSelectedPost() > 0;
        }
        else {
            return this.countNumberSelectedInfluencer() > 0;
        }
    };
    BottombarInfluencerFragementComponent.prototype.countNumberSelectedInfluencer = function () {
        return this.influencerList.filter(function (influencer) { return influencer.selected === true; }).length;
    };
    BottombarInfluencerFragementComponent.prototype.countNumberSelectedPost = function () {
        return this.postList.filter(function (influencer) { return influencer.selected === true; }).length;
    };
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "countNumberReviewedInfluencer", {
        get: function () {
            return this.influencerList.filter(function (influencer) { return influencer.selected && influencer.previewed; }).length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "countNumberReviewedPost", {
        get: function () {
            return this.postList.filter(function (post) { return post.selected && post.previewed; }).length;
        },
        enumerable: true,
        configurable: true
    });
    BottombarInfluencerFragementComponent.prototype.hasPreviewedInfluencer = function () {
        var listPreviewedInfluencer = this.influencerList.filter(function (influencer) { return influencer.selected && influencer.previewed; });
        var listPreviewedPost = this.postList.filter(function (influencer) { return influencer.selected && influencer.previewed; });
        return listPreviewedInfluencer.length > 0 || listPreviewedPost.length > 0;
    };
    BottombarInfluencerFragementComponent.prototype.openBottomBarToPreview = function () {
        this.openBottomBarCallback.emit(CommonConstant.DEFAULT_BOTTOMBAR_MAX_HEIGHT);
    };
    BottombarInfluencerFragementComponent.prototype.showPreviewInfluencer = function () {
        this.showPreviewSelectedInfluencerFragment = true;
        this.openBottomBarToPreview();
    };
    BottombarInfluencerFragementComponent.prototype.closeBottomBarWithTransition = function () {
        var _this = this;
        setTimeout(function () {
            _this.closeAllActionsFragment();
        }, CommonConstant.TRANSITION_TIME);
        this.clearSelectionCallback.emit(this.tabKey);
        this.closeBottomBarCallback.emit(false);
    };
    BottombarInfluencerFragementComponent.prototype.manageDisplayTabAndCloseBottombar = function () {
        if (this.countNumberSelectedInfluencer() === 0 && this.countNumberSelectedPost() === 0) {
            this.previewBottomBarOpen.emit(false);
            this.closeBottomBarWithTransition();
        }
        else {
            if (this.tabKey === DiscoverTab.INFLUENCER && this.countNumberSelectedInfluencer() > 0) {
                return;
            }
            if (this.tabKey === DiscoverTab.POST && this.countNumberSelectedPost() > 0) {
                return;
            }
        }
    };
    BottombarInfluencerFragementComponent.prototype.unCheckAllInfluencers = function () {
        this.influencerList.forEach(function (influencer) {
            influencer.selected = false;
            influencer.previewed = false;
        });
    };
    BottombarInfluencerFragementComponent.prototype.unCheckAllPosts = function () {
        this.postList.forEach(function (post) {
            post.selected = false;
            post.previewed = false;
        });
    };
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "activePage", {
        get: function () {
            return {
                type: this.discoverInfluencer ? ActivePages.DISCOVER : ActivePages.GROUP_DETAILS
            };
        },
        enumerable: true,
        configurable: true
    });
    BottombarInfluencerFragementComponent.prototype.groupSettingActionData = function () {
        return {
            action: UserActionType.ACTION,
            item: Page.GROUP,
            target: {
                type: TargetType.INFLUENCER_GROUP
            },
            params: {
                action: UserActionType.UPDATE,
                source: ActionSource.PAGE,
                actionDetails: ActionDetails.UPDATE_CONFIG,
            },
            activePage: {
                type: ActivePages.GROUP_DETAILS,
            }
        };
    };
    BottombarInfluencerFragementComponent.prototype.actionDataForAddingInfluencer = function () {
        if (this.campaignInfluencerList) {
            return this.actionData('campaign');
        }
        if (this.isUsingForGroupDetail) {
            return this.actionData('group');
        }
        return null;
    };
    /**
     * data will be used to send to Segment
     * @returns {{action: UserActionType; item: Page; target: ({type: Page} | {id: (number | any); name: (string | any); type: TargetType}); params: {action: UserActionType; source: ActionSource; actionDetails: ActionDetails}; activePage: {type: ActivePages}}}
     */
    BottombarInfluencerFragementComponent.prototype.actionData = function (target) {
        var item = target === 'group' ? Page.GROUP : target === 'campaign' ? Page.CAMPAIGN : Page.PROJECT;
        return {
            action: UserActionType.ACTION, item: item,
            target: {
                type: item
            },
            params: {
                action: UserActionType.UPDATE,
                source: ActionSource.ACTION_VIEW,
                actionDetails: ActionDetails.ADDED_INFLUENCERS,
            },
            activePage: {
                type: this.discoverInfluencer ? ActivePages.DISCOVER : this.isUsingForGroupDetail ? ActivePages.GROUP_DETAILS : ActivePages.CAMPAIGN_DETAILS,
            }
        };
    };
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "selectedProfileLabel", {
        get: function () {
            if (this.campaignInfluencerList || this.isRecentlyVisitedInfluencerGroup) {
                return this.translateService.instant('campaigns.selected_campaign_influencer', { selected_number: this.countNumberSelectedInfluencer() });
            }
            else {
                return this.translateService.instant('group_details.search_bar.selected_influencer', { selected_number: this.countNumberSelectedInfluencer() });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "actionByLevel", {
        // get account level action for delete button depend on the context
        get: function () {
            // not support this button in discover
            if (this.discoverInfluencer) {
                return null;
            }
            if (this.campaignInfluencerList) {
                return CommonConstant.BASIC_CAMPAIGN_ACTION;
            }
            else {
                return CommonConstant.DELETE_INFLUENCER_FROM_GROUP;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "wallName", {
        get: function () {
            // not support this button in discover
            if (this.discoverInfluencer) {
                return null;
            }
            if (this.campaignInfluencerList) {
                return WallName.CAMPAIGNS_DISABLED;
            }
            else {
                return WallName.GROUPS_DISABLED;
            }
        },
        enumerable: true,
        configurable: true
    });
    BottombarInfluencerFragementComponent.prototype.getCampaign = function () {
        var currentCampaign = new Campaign();
        currentCampaign.id = this.campaignId;
        return currentCampaign;
    };
    Object.defineProperty(BottombarInfluencerFragementComponent.prototype, "deleteInfluencerContext", {
        get: function () {
            if (this.campaignInfluencerList) {
                return this.translateService.instant('common.campaign');
            }
            else {
                return this.translateService.instant('common.group');
            }
        },
        enumerable: true,
        configurable: true
    });
    BottombarInfluencerFragementComponent.prototype.closeAddInfluencerToCampaign = function (data) {
        if (data.resetSelectedInfluencer) {
            this.pendingInfluencerListAddToCampaign = [];
        }
        this.selectedInfluencerToAddCampaign = [];
        this.showAddInfluencerToCampaigns = false;
        this.addInfluencerToCampaignAsAccepted = false;
        this.closeBottomBarCallback.emit();
    };
    BottombarInfluencerFragementComponent.prototype.addMoreInfluencerToCampaign = function (influencerData) {
        var _this = this;
        var isAccepted;
        // get current campaign info
        var currentCampaign = this.campaignList.find(function (campItem) { return campItem.id === _this.campaignId; });
        var campaignInfluencers = [];
        this.pendingInfluencerListAddToCampaign = influencerData;
        // update UI
        influencerData.forEach(function (influencer) {
            isAccepted = influencer.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name;
            var influencerCountry = _this.extractInfluencerCountry(influencer);
            campaignInfluencers.push({
                campaign_influencer_id: null,
                influencer_id: influencer.influencer_id,
                influencer_name: influencer.influencerName,
                influencerStatus: influencer.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name ? influencer.status.toLowerCase() : CampaignInfluencerStatus.NEW.toLowerCase(),
                numberOfPosts: influencer.numberOfPosts,
                reach: influencer.reach,
                engagement: influencer.engagement,
                impact: influencer.impact,
                influencer_profile_picture: influencer.profilePicture,
                country_code: influencerCountry.code,
                country: {
                    name: influencerCountry.name,
                    code: influencerCountry.code
                },
                is_accepted: influencer.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name
            });
            influencer.status = influencer.status.toLowerCase();
        });
        var filteredNewAcceptInfluencer = [];
        filteredNewAcceptInfluencer = campaignInfluencers.filter(function (item) { return item.is_accepted; });
        this.addInfluencerToCurrentCampaign.emit(campaignInfluencers);
        this.closeAddInfluencerToCampaign({
            resetSelectedInfluencer: false
        });
        // Call WS
        var data = new AddInfluencersCampaign();
        data.campaign_id = this.campaignId;
        data.influencers = influencerData;
        data.is_accepted = isAccepted;
        this.campaignService.addInfluencerToCampaign(data).subscribe(function (res) {
            if (filteredNewAcceptInfluencer && filteredNewAcceptInfluencer.length > 0) {
                _this.addInfluencerAsAccepted.emit();
            }
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                id: currentCampaign.id,
                name: currentCampaign.name,
                type: TargetType.CAMPAIGN
            }, __assign({ action: UserActionType.UPDATE, actionDetails: ActionDetails.ADDED_INFLUENCERS, source: ActionSource.ACTION_VIEW }, data), undefined, {
                type: ActivePages.CAMPAIGN_DETAILS,
            });
            // Tracking cham event
            if (filteredNewAcceptInfluencer && filteredNewAcceptInfluencer.length === 0) {
                _this.sendChamMixpanelEvent(true);
            }
            // clean cached influencer list
            _this.pendingInfluencerListAddToCampaign = [];
            _this.selectedInfluencerToAddCampaign = [];
            _this.addInfluencerToCampaignAsAccepted = false;
            _this.userService.triggerUpdateActivatedInfluencers();
        }, function (error) {
            _this.showAddInfluencerFragment();
            _this.addInfluencerToCampaignError.emit();
            if (error && error.error.data === 'invalid_level') {
                _this.userService.doInvalidActionByLevel('Add to Campaign', error.error.message);
                _this.sendInvalidActionToSegement(_this.influencerGroupService.extractLimitInfoFromErrorMessage(error.error.message, influencerData.length, _this.userService.maxGroupInfluencers, false), null, {
                    campaign_id: currentCampaign.id,
                    campaign_name: currentCampaign.name,
                    influencers: influencerData
                });
            }
        });
    };
    BottombarInfluencerFragementComponent.prototype.sendChamMixpanelEvent = function (isAddedInfluencerToCampaign) {
        if (isAddedInfluencerToCampaign) {
            this.eventTracker.trackUserAction(UserActionType.CHAM_INVITED_CAMPAIGN_INFLUENCER);
        }
        else {
            this.eventTracker.trackUserAction(UserActionType.CHAM_ADD_INFLUENCER_TO_GROUP);
        }
    };
    BottombarInfluencerFragementComponent.prototype.extractInfluencerCountry = function (influencer) {
        if (influencer.country) {
            return influencer.country;
        }
        else if (influencer.countryCode) {
            return this.referenceDataService.countries.find(function (item) { return item.code === influencer.countryCode; });
        }
        else {
            return CommonConstant.INTERNATIONAL_COUNTRY_DATA;
        }
    };
    BottombarInfluencerFragementComponent.prototype.showGroupSettings = function () {
        if (this.isUsingForGroupDetail) {
            this.openGroupSetting.emit();
        }
    };
    return BottombarInfluencerFragementComponent;
}());
export { BottombarInfluencerFragementComponent };



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/bottombar-influencer-fragement.component.ts.pre-build-optimizer.js